import { Style } from "@/types/design";

export const ContentStyleImages:Style[]  = [
  //装饰
  { name: '通用', category: '室内设计', src: 'style_generic.jpg' },
  { name: '新中式', category: '室内设计', src: 'style_img1.jpg' },
  { name: '欧式', category: '室内设计', src: 'style_img2.jpg' },
  { name: '现代简约', category: '室内设计', src: 'style_img3.jpg' },
  { name: '北欧', category: '室内设计', src: 'style_img4.jpg' },
  { name: '英伦', category: '室内设计', src: 'style_img5.jpg' },
  { name: '巴洛克', category: '室内设计', src: 'style_img6.jpg' },
  { name: '波西米亚', category: '室内设计', src: 'style_img7.jpg' },
  { name: '地中海', category: '室内设计', src: 'style_img8.jpg' },
  { name: '和式', category: '室内设计', src: 'style_img9.jpg' },
  { name: '侘寂', category: '室内设计', src: 'style_img10.jpg' },
  { name: '法国浪漫', category: '室内设计', src: 'style_img11.jpg' },
  { name: '大美式', category: '室内设计', src: 'style_img12.jpg' },
  { name: '中式经典', category: '室内设计', src: 'style_img13.jpg' },
  { name: '南洋', category: '室内设计', src: 'style_img14.jpg' },
  { name: 'Art deco', category: '室内设计', src: 'style_img15.jpg' },
  { name: '轻奢', category: '室内设计', src: 'style_img16.jpg' },
  { name: '田园', category: '室内设计', src: 'style_img17.jpg' },
  { name: '东南亚', category: '室内设计', src: 'style_img18.jpg' },
  { name: '古罗马', category: '室内设计', src: 'style_img19.jpg' },
  { name: '黑白', category: '室内设计', src: 'style_img20.jpg' },
  { name: '宜家', category: '室内设计', src: 'style_img21.jpg' },
  { name: '乡村', category: '室内设计', src: 'style_img22.jpg' },
  { name: '新古典主义', category: '室内设计', src: 'style_img23.jpg' },
  { name: '哥特', category: '室内设计', src: 'style_img24.jpg' },


  //建筑
  { name: '通用', category: '建筑设计', src: 'style_generic.jpg' },
  { name: '办公建筑', category: '建筑设计', src: 'style_architecture1.jpg' },
  { name: '别墅建筑', category: '建筑设计', src: 'style_architecture2.jpg' },
  { name: '城市鸟瞰', category: '建筑设计', src: 'style_architecture3.jpeg' },
  { name: '城市透视', category: '建筑设计', src: 'style_architecture4.jpeg' },
  { name: '度假建筑', category: '建筑设计', src: 'style_architecture5.jpeg' },
  { name: '工业建筑', category: '建筑设计', src: 'style_architecture6.jpeg' },
  { name: '观演建筑', category: '建筑设计', src: 'style_architecture7.jpeg' },
  { name: '教育建筑', category: '建筑设计', src: 'style_architecture8.jpeg' },
  { name: '赛博建筑', category: '建筑设计', src: 'style_architecture9.jpeg' },
  { name: '商业建筑', category: '建筑设计', src: 'style_architecture10.jpg' },
  { name: '乡村建筑', category: '建筑设计', src: 'style_architecture11.jpeg' },
  { name: '中式建筑', category: '建筑设计', src: 'style_architecture12.jpg' },
  { name: '住宅建筑', category: '建筑设计', src: 'style_architecture13.jpeg' },
  { name: '总平面', category: '建筑设计', src: 'style_architecture14.jpg' },

  //规划
  { name: '通用', category: '规划设计', src: 'style_generic.jpg' },

  //景观
  { name: '通用', category: '景观设计', src: 'style_generic.jpg' },

  //其他
  { name: '通用', category: '其他', src: 'style_generic.jpg' },
];